import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B04D02LaybyListPage } from '../b04-d02-layby-list/b04-d02-layby-list';

/**
 * Generated class for the B04LaybyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface SOInfo{
  SO_ID: number;
  SO_NO: string;
  CARD: string;
  DATETIME: string;
  GRAND_TOTAL: number; 
  ACTION_BY: number;

  SO_STATUS_ID: number;
  STATUS: string;

  BRANCH_ID: number;
  BRANCH_NAME: string;
}

interface branchInfo{
  BRANCH_ID: number;
  BRANCH_NAME: string;
}

@IonicPage()
@Component({
  selector: 'page-b04-layby',
  templateUrl: 'b04-layby.html',
})
export class B04LaybyPage {
  loading: any;
  Status: any;
  SOArr: SOInfo[] = [];
  SOItems: SOInfo[] = [];
  branchArr: branchInfo[] = [];
  branchItems: branchInfo[] = [];
  public errorMessage: any = "";
  GRP_ID: any;
  BRANCH_ID: any;
  
  constructor(public navCtrl: NavController, public navParams: NavParams, public serviceapi: ServiceApiProvider,
              public loadingCtrl: LoadingController,) {

    this.GRP_ID = sessionStorage.getItem('usergroupid');
    this.BRANCH_ID = sessionStorage.getItem('userbranchid');

    if (this.GRP_ID == "1") {
      let tbl = ["All"];
      let column = ["All"];
      let value = ["All"];
      
      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"];
    
      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      this.showLoader();
      this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
        this.Status = result["Message"];
        if (this.Status == '1'){
          
          let Records = result["Records"];
          this.branchArr = Records;
          this.branchItems = this.branchArr;

          this.BRANCH_ID = this.branchArr[0].BRANCH_ID;
          this.soData();
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          this.loading.dismiss();
        }
      }, (err) => {
        this.errorMessage = "Branch Info Loading Error. Please try again. Error Code: '" + err + "'";
        this.loading.dismiss();
      });
    }
    else {
      this.showLoader();
      this.soData();
    }
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad B07LaybyPage');
  }

  soData(){
    let sortby= "SO_ID";
    let sorttype= "DESC";
    
    let tbl = ["SO2", "BRANCH"];
    let column = ["SO_STATUS_ID", "BRANCH_ID"];
    let value = ['1', this.BRANCH_ID];

    let tblkey = ["SO_STATUS_ID", "BRANCH_ID"];
    let fktbl = ["SO_STATUS", "BRANCH" ];
    let fkkey = ["SO_STATUS_ID", "BRANCH_ID"];
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");

    this.serviceapi.readdata(json_data,"SO2","1","1").then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
    
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.SOArr = Records;
        this.SOItems = this.SOArr;

       // console.log(this.SOItems);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
      this.loading.dismiss();
    });
  }

  viewUser(ID){
    this.navCtrl.push(B04D02LaybyListPage, {paramID: ID});    //SO ID
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000,
    });
    this.loading.present();
  }

  searchItem(){
    this.SOArr = [];
    this.SOItems = [];
    this.errorMessage = '';
    this.soData();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b04-layby/b04-layby.ts